import React, {Component, Fragment} from 'react'
import {Icon} from 'antd'

const PageTitle = ({title, subtitle, iconType, color}) => (
  <Fragment>
    <h1 style={{marginLeft: '20px', marginTop: '20px', fontWeight: 'bold'}}>
      <Icon type={iconType} style={{marginRight: 10, color: color}} />
      {title}
    </h1>
    <p style={{marginLeft: '20px', marginTop: '10px'}}>{subtitle}</p>
  </Fragment>
)

export default PageTitle
